export const Answer = {
  No: 0,
  Yes: 1,
}

export const NormalizedAnswer = {
  [Answer.No]: 'No',
  [Answer.Yes]: 'Yes',
}
